import _ from 'lodash';

const BATCH_FAILED_STATUS = 'FAILED';
const BATCH_CANCELLED_STATUS = 'CANCELLED';
const BATCH_COMPLETE_STATUS = 'COMPLETE';
const BlankIntegrationInstance = require('./../../models/blankIntegrationInstance');
const oneRosterApiType = 'OneRosterApiV1';

class SecureOneRosterApiConnectionController {
  constructor(customerIntegrationsService, config, httpDim, batchService, statusIndicatorService) {
    this.name = 'secureAeriesConnection';
    this.customerIntegrationsService = customerIntegrationsService;
    this.config = config;
    this.httpDim = httpDim;
    this.batchService = batchService;
    this.userWantsToEditKey = false;
    this.uploadHasSucceeded = false;
    this.statusIndicatorService = statusIndicatorService;
    this.isDisabled = false;
    this.schema = {};
    this.forceSync = false;
    this.checkBatchStatus();
    this.getSchema();
  }

  checkBatchStatus() {
    this.statusIndicatorService.getStatus().then(this.onStatusReceived.bind(this));
  }

  onStatusReceived(response) {
    let status = response.data.content ? response.data.content.status : null;
    this.isDisabled = !(status === BATCH_COMPLETE_STATUS || status === BATCH_FAILED_STATUS || status === BATCH_CANCELLED_STATUS);
  }

  getSchema() {
    this.customerIntegrationsService.getSchema(oneRosterApiType)
      .then(this.setSchema.bind(this))
      .then(this.getCustomerIntegrations.bind(this))
      .then(this.onIntegrationsRetrieved.bind(this))
      .catch(this.onIntegrationsRetrievalFailed);
  }

  setSchema(response) {
    this.schema = response.data.content;
    _.each(this.schema.keys, (key, name) => {
      key.instance = new BlankIntegrationInstance(name, oneRosterApiType, key.default);
      key.disabled = false;
    });
  }


  getCustomerIntegrations() {
    return this.customerIntegrationsService.getCustomerIntergration(oneRosterApiType);
  }

  onIntegrationsRetrieved(response) {
    let integrations = response.data.content;
    integrations.forEach((integration) => { this.schema.keys[integration.key].instance = integration; });

    if (this.formIsNotValid()) {
      this.setEditingState();
    }
  }


  showEl(key){
    const clientValidation = _.find(key.clientValidations,{method : 'toShow'});
    if (key.optional && clientValidation) {
      const conditionFieldIntegration = this.schema.keys[clientValidation.conditionField];
      const isRequired = conditionFieldIntegration && conditionFieldIntegration.instance.value === conditionFieldIntegration.default;
      key.disabled = isRequired;
      return  !isRequired;
    }
    return !key.private ;
  }

  removeOptionalKeysFromSchema(integrations) {
    let optionalKeys = this.getOptionalKeys(integrations);
    _.each(optionalKeys,(key)=>{
      delete this.schema.keys[key];
    });
  }

  getOptionalKeys(integrations) {
    let optionalKeysSchemas = _.filter(this.schema.keys, (key) => {
      if (key.optional) {
        let clientValidation = _.find(key.clientValidations,{method : 'toShow'});
        let conditionFieldIntegration = _.find(integrations,{key: clientValidation.conditionField});
        let isRequired = conditionFieldIntegration && conditionFieldIntegration.value === clientValidation.conditionValue;
        return  !isRequired;
      }
    });
    let optionalKeys = _.map(_.map(optionalKeysSchemas,'instance'),'key');
    return optionalKeys;
  }

  onIntegrationsRetrievalFailed() {
    console.log('There was an error retrieving your apiKey.');
  }

  setEditingState() {
    this.userWantsToEditKey = true;
  }

  formIsNotValid() {
    var url, consumerKey, consumerSecret;

    if (this.schema.keys) {
      url = this.schema.keys.url;
      consumerKey = this.schema.keys.consumerKey;
      consumerSecret = this.schema.keys.consumerSecret;
    }

    return (
      !url ||
      !consumerKey ||
      !consumerSecret ||
      !url.instance ||
      !consumerKey.instance ||
      !consumerSecret.instance ||
      !url.instance.value ||
      !consumerKey.instance.value ||
      !consumerSecret.instance.value
    );
  }

  syncNow() {
    this.clearErrors();

    const enabledInstances = _.reject(this.schema.keys, (key) => {return key.disabled === true ;});
    const integrations = _.map(enabledInstances, (key) => {return key.instance;});
    this.forceSync = true;
    return this.customerIntegrationsService.update(integrations)
      .then(this.createBatch.bind(this))
      .catch(this.onIntegrationsUpdateFailure.bind(this));
  }

  onIntegrationsUpdateFailure(err) {
    err.keys.forEach((key) => {
      this.schema.keys[key].error = err.message;
    });
  }

  createBatch() {
    this.userWantsToEditKey = false;
    this.batchService.createBatch(oneRosterApiType, this.forceSync).then(
      this.onSyncCompleted.bind(this),
      this.onSyncFailed.bind(this)
    );
  }

  clearErrors() {
    _.each(this.schema.keys, (key) => { delete key.error; });
  }

  onSyncCompleted() {
    this.uploadHasSucceeded = true;
    this.userWantsToEditKey = false;
    this.forceSync = false;
  }

  onSyncFailed() {
    this.updateHasFailed = true;
    this.forceSync = false;
    console.log('Your sync has failed!');
  }
}

SecureOneRosterApiConnectionController.$inject = ['customerIntegrationsService', 'config', 'httpDim', 'batchService', 'statusIndicatorService'];

export default SecureOneRosterApiConnectionController;



// WEBPACK FOOTER //
// ./app/components/secureOneRosterApiConnection/secureOneRosterApiConnection.controller.js